import ReactDOM from 'react-dom';
import App from './App';
import { mockCallback } from 'src/utils/mockups/mockProps';

ReactDOM.render(
  <App onChangeSubjectNum={mockCallback} onChangeStudyPlan={mockCallback} />,
  document.getElementById('root')
);
